import { logger } from '../util/logger';
const transformedData = (data) => {
    if (data) {
        return typeof data === 'string' ? data : JSON.stringify(data);
    }
    return null;
};
const fetchParams = {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
};
const fetchParamsNoHeaders = {
    ...fetchParams,
    headers: {}
};
const post = async (url, data) => fetch(url, {
    ...fetchParams,
    method: 'POST',
    body: transformedData(data)
});
const patch = async (url, data) => fetch(url, {
    ...fetchParams,
    method: 'PATCH',
    body: transformedData(data)
});
const put = async (url, data) => fetch(url, {
    ...fetchParams,
    method: 'PUT',
    body: transformedData(data)
});
const get = async (url, excludeHeaders = false) => {
    const getParams = excludeHeaders ? fetchParamsNoHeaders : fetchParams;
    return fetch(url, {
        ...getParams,
        method: 'GET'
    });
};
const parseData = (resp) => resp.json().then((json) => {
    logger.log(json);
    return json.d;
});
const parseDataPermissionException = (resp) => resp.json().then((json) => {
    if (json?.ExceptionType) {
        throw new Error(json.ExceptionType);
    }
    logger.log(json);
    return json.d;
});
class RejectException extends Error {
    constructor(message) {
        super(message);
        this.name = 'ServerResponseReject';
    }
}
const validateResponse = (resp) => {
    const { Status, Message } = resp;
    if (Status === 'reject') {
        throw new RejectException(Message);
    }
    if (Status === 'error') {
        throw new Error();
    }
    return resp;
};
const apiPrefix = '/WebApi/api';
export { get, RejectException, parseData, parseDataPermissionException, post, patch, put, validateResponse, apiPrefix };
